import { render, staticRenderFns } from "./CreatePostButtonView.vue?vue&type=template&id=cea30920&scoped=true&"
import script from "./CreatePostButtonView.vue?vue&type=script&lang=ts&"
export * from "./CreatePostButtonView.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePostButtonView.vue?vue&type=style&index=0&id=cea30920&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea30920",
  null
  
)

export default component.exports